import * as Sentry from '@sentry/react-native';

import { isAbortError, isExpectedAuthLinkError, isSupabaseErrorLike, toError } from '@/utils/errors';

/**
 * Centralized replacement for Sentry.captureException:
 * - drops aborted-request noise (transient, not actionable),
 * - normalizes Supabase plain-object errors into real Error instances,
 * - keeps code/details/hint visible in Sentry via a `supabase` context.
 */
export function reportError(err: unknown, extras?: Record<string, unknown>): void {
  if (isAbortError(err) || isExpectedAuthLinkError(err)) return;

  Sentry.captureException(toError(err), {
    contexts: isSupabaseErrorLike(err)
      ? { supabase: { code: err.code ?? null, details: err.details ?? null, hint: err.hint ?? null } }
      : undefined,
    extra: extras,
  });
}
